import {
  PARTY,
  JURISDICTION,
  QS,
  ENDORSEMENT,
  ALPHABET,
  ENDORSEMENT_ORDER,
} from '../components/election/constants.js';
import { Contest, Candidate, Judge, Measure } from '../components/election/data_objs.js';

const defaultOrder = ALPHABET;
// Name ordering for June 2026 primary contests - will be updated when available
const localOrder = ALPHABET; // Placeholder - update when SF Department of Elections announces

// These are listed in the order in which they'll appear on the ballot
export const june26_contests = {
  'Supervisor, District 2': Contest(
    JURISDICTION.LOCAL,
    {
      en: 'Supervisor, District 2',
      zh: '市議員，第2選區',
      es: 'Junta de Supervisores, Distrito 2',
      fil: 'Lupon ng mga Superbisor, Distrito 2',
    },
    [
      Candidate(
        { en: 'Lori Brooke' },
        PARTY.NP,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidata',
          fil: 'Kandidato',
        },
        QS.DECLINED,
      ),
      Candidate(
        { en: 'Daniel Genduso' },
        PARTY.NP,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidato',
          fil: 'Kandidato',
        },
        QS.NO_CONTACT,
      ),
      Candidate(
        { en: 'Jeremy Kirshner' },
        PARTY.NP,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidato',
          fil: 'Kandidato',
        },
        QS.NO_CONTACT,
      ),
      Candidate(
        { en: 'Monthanus Ratanapakdee' },
        PARTY.NP,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidata',
          fil: 'Kandidato',
        },
        QS.NO_CONTACT,
      ),
      Candidate(
        { en: 'Stephen Sherrill' },
        PARTY.NP,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidato',
          fil: 'Kandidato',
        },
        '/voter-guide/questionnaires/june-2026/stephen-sherrill',
        true,
      ),
    ],
    localOrder,
  ),
  'Supervisor, District 4': Contest(
    JURISDICTION.LOCAL,
    {
      en: 'Supervisor, District 4',
      zh: '市議員，第4選區',
      es: 'Junta de Supervisores, Distrito 4',
      fil: 'Lupon ng mga Superbisor, Distrito 4',
    },
    [
      Candidate(
        { en: 'Alan Wong' },
        PARTY.DEM,
        {
          en: 'District 4 Supervisor; Incumbent (appointed)',
          zh: '第4選區市議員',
          es: 'Supervisora del Distrito 4',
          fil: 'Superbisor ng Distrito 4',
        },
        '/voter-guide/questionnaires/june-2026/alan-wong',
        true,
      ),
      Candidate(
        { en: 'Albert Chow' },
        PARTY.DEM,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidato',
          fil: 'Kandidato',
        },
        QS.NO_RESPONSE,
      ),
      Candidate(
        { en: 'Natalie Gee' },
        PARTY.DEM,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidato',
          fil: 'Kandidato',
        },
        QS.DECLINED,
      ),
      Candidate(
        { en: 'Jeremy Greco' },
        PARTY.DEM,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidato',
          fil: 'Kandidato',
        },
        QS.NO_RESPONSE,
      ),
      Candidate(
        { en: 'David Lee' },
        PARTY.DEM,
        {
          en: 'Candidate',
          zh: '候選人',
          es: 'Candidato',
          fil: 'Kandidato',
        },
        QS.NO_RESPONSE,
      ),
    ],
    localOrder,
  ),
  'Board of Education': Contest(
    JURISDICTION.LOCAL,
    {
      en: 'Board of Education',
      zh: '教育委員會成員',
      es: 'Miembro, Consejo de Educación',
      fil: 'Miyembro, Lupon ng Edukasyon',
    },
    [
      Candidate(
        { en: 'Phil Kim', zh: '金菲爾' },
        PARTY.NP,
        {
          en: 'Board of Education President; Incumbent',
          zh: '教育委員會主席；現任',
          es: 'Presidenta de la Junta de Educación; Titular',
          fil: 'Pangulo ng Lupon ng Edukasyon; Kasalukuyan',
        },
        'https://drive.google.com/file/d/1ytmTyp6iYBBai2WSaQyYp3zGybUXL7am/view?usp=drive_link',
        true,
      ),
      Candidate(
        { en: 'Brandee Marckmann' },
        PARTY.NP,
        {
          en: 'Activist',
        },
        QS.NO_RESPONSE,
        false,
      ),
    ],
    localOrder,
  ),
};

// Helper exports for issues/positions data that will be used in the voter guide
export const june26_d2_header = [
  { key: 'position', label: 'Position' },
  { key: 'sherrill', label: 'Stephen Sherrill' },
];

export const june26_positions_d2 = [];
